( ( $ ) => {

	$( '.quantity-counter' ).each( ( index, el ) => {
		const $input = $( 'input', el );
		const $btnMinus = $( 'button[data-type="minus"]', el );
		const $btnPlus = $( 'button[data-type="plus"]', el );

		$btnPlus.on( 'click', function ( event ) {
			if ( $btnMinus.is( ':disabled' ) ) {
				$btnMinus.prop( "disabled", false );
			}
			let value = parseInt( $input.val(), 10 );
			value++;
			$input.val( value );
			$input.trigger( 'wpshopify.quantityChanged', [ value ] );

		} );

		$btnMinus.on( 'click', function ( event ) {

			let value = parseInt( $input.val(), 10 );
			value--;
			if ( value <= 1 ) {
				value = 1;

				$btnMinus.prop( "disabled", true );

			}
			$input.val( value );
			$input.trigger( 'wpshopify.quantityChanged', [ value ] );

		} );

		$input.on( 'change', function ( event ) {
			let value = parseInt( $input.val(), 10 );
			if ( isNaN( value ) ) {
				value = 1;
			}
			value = value <= 1 ? 1 : value;
			$input.val( value );
			$input.trigger( 'wpshopify.quantityChanged', [ value ] );
		} );

		$input.on( 'wpshopify.quantityChanged.refresh', function ( event ) {
			let value = parseInt( $input.val(), 10 );
			if ( isNaN( value ) ) {
				value = 1;
				$input.val( value );
			}

			if ( value <= 1 ) {
				$btnMinus.prop( "disabled", true );
			} else {
				$btnMinus.prop( "disabled", false );
			}

		} );

	} );

} )( jQuery )